module.exports = __webpack_public_path__ + "fonts/iconfont.f429bf56.ttf";